<app-header [forceLightBackground]="true"></app-header>
<div class="provider-add-model">
  <div class="provider-add-model--layout">
    <app-provider-sidebar class="provider-add-model--sidebar"></app-provider-sidebar>
    <div class="provider-add-model--content">
      <div class="provider-add-model--body">
        <app-page-header [showDivider]="false"></app-page-header>
      </div>
      <hr class="provider-add-model--title-divider" />
      <div class="provider-add-model--body">
        <div class="page-container">
          <lib-model-onboarding-home
            publisherRole="provider"
            (submitError)="onSubmitError($event)"
            (submitSuccess)="onSubmitSuccess($event)"
          />
        </div>
      </div>
    </div>
  </div>
</div>
